import React, { useState } from 'react';
import { CirclePause, UserX } from 'lucide-react';
import { usePermissions } from '../../context/PermissionsContext';
import { clearAuthData } from '../../utils/apiKeyAuth';
import { LOCKOUT_COPY } from '../../constants/partnerCopy';
import styles from './LockoutScreen.module.scss';

/**
 * Full-page blocking screen for session lockouts (Partner tier guide §9).
 *
 * Rendered by App in place of the sidebar + routes, so every page (and its
 * polling) unmounts. The session is kept: "Try again" re-checks permissions and a
 * still-locked session simply raises the lockout again.
 */
const LockoutScreen = ({ kind = 'user' }) => {
  const { retryAfterLockout } = usePermissions();
  const [retrying, setRetrying] = useState(false);
  const copy = LOCKOUT_COPY[kind] || LOCKOUT_COPY.user;
  const Icon = kind === 'user' ? UserX : CirclePause;

  const handleRetry = async () => {
    setRetrying(true);
    try {
      await retryAfterLockout();
    } finally {
      setRetrying(false);
    }
  };

  const handleSignOut = () => {
    clearAuthData();
    window.location.href = '/login';
  };

  return (
    <div className={styles.page} role="alert">
      <div className={styles.card}>
        <div className={styles.iconWrap}>
          <Icon size={34} strokeWidth={2} />
        </div>
        <h1 className={styles.title}>{copy.title}</h1>
        <p className={styles.body}>{copy.body}</p>
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.primary}
            onClick={handleRetry}
            disabled={retrying}
          >
            {retrying ? 'Checking…' : 'Try again'}
          </button>
          <button type="button" className={styles.secondary} onClick={handleSignOut}>
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
};

export default LockoutScreen;
